import React, { useRef, useEffect } from 'react';

export const VideoShowcase = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && videoRef.current) {
            videoRef.current.play().catch(err => console.log('Video play failed:', err));
          }
        });
      },
      { threshold: 0.3 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-[#0A1F3D] to-[#0D2847]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">
            Experience Our <span className="text-[#C9A14A]">Projects</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed px-4">
            Take a virtual tour of our premium properties and developments
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#C9A14A] to-transparent mx-auto mt-6 sm:mt-8" />
        </div>

        {/* Video Container */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
          {/* Enhanced Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F3D]/80 via-transparent to-[#0A1F3D]/40 z-10 pointer-events-none" />
          
          {/* Video */}
          <video
            ref={videoRef}
            className="w-full h-auto transform transition-transform duration-700 group-hover:scale-105"
            loop
            muted
            playsInline
            controls
          >
            <source
              src="https://customer-assets.emergentagent.com/job_saketh-luxury/artifacts/v3klxw4w_VID-20260326-WA0019.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>

          {/* Premium Corner Accents */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-[#C9A14A]/20 blur-3xl rounded-full" />
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-[#C9A14A]/20 blur-3xl rounded-full" />
        </div>

        {/* Video Caption */}
        <div className="text-center mt-10">
          <p className="text-gray-300 italic text-lg">
            "Luxury living redefined with world-class amenities and strategic locations"
          </p>
        </div>
      </div>
    </section>
  );
};
